<!--
import BaseModalCamera from '@/components/base/BaseModalCamera.vue';
-->

<template>
  <b-modal
    v-model="isModalVisible"
    centered
    hide-header
    hide-footer
    no-close-on-esc
    no-close-on-backdrop
  >
    <video
      ref="camera"
      width="100%"
      :height="CANVAS_WIDTH"
      autoplay
      playsinline
      muted
      style="background-color: #000"
    ></video>

    <canvas
      ref="canvas"
      class="photo-taken"
      :width="CANVAS_WIDTH"
      :height="CANVAS_HEIGHT"
    ></canvas>

    <b-row class="mt-3">
      <b-col cols="12" md="6">
        <b-button pill block variant="secondary" @click="onCapture">
          Capture
        </b-button>
        <div class="mb-3 d-md-none"></div>
      </b-col>

      <b-col cols="12" md="6">
        <b-button
          pill
          block
          variant="outline-info"
          @click="isModalVisible = false"
        >
          Cancel
        </b-button>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
// utils
import { getRef } from "@/utils/dom";

const CANVAS_WIDTH = 325;
const CANVAS_HEIGHT = 250;

export default {
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    facingMode: {
      type: String,
      default: "environment",
      validate(val) {
        return ["user", "environment"].includes(val);
      },
    },
  },

  data() {
    return {
      CANVAS_WIDTH,
      CANVAS_HEIGHT,
    };
  },

  computed: {
    isModalVisible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },

  watch: {
    async isModalVisible(isModalVisible) {
      if (isModalVisible) {
        await this.createCameraElement();
      }
    },
  },

  methods: {
    async createCameraElement() {
      try {
        const camera = await getRef.call(this, "camera");

        const constraints = {
          audio: false,
          video: {
            facingMode: this.facingMode,
          },
        };

        window.constraints = constraints;

        const stream = await navigator.mediaDevices.getUserMedia(constraints);

        camera.srcObject = stream;
      } catch (error) {
        console.error(error);

        if (error.name == "NotAllowedError") {
          this.isModalVisible = false;

          this.$emit(
            "showAlert",
            "Camera is not detected. Please turn on your camera and refresh your browser."
          );
        }
      }
    },

    stopCameraStream() {
      const camera = this.$refs.camera;

      if (!camera?.srcObject) {
        return;
      }

      const tracks = camera.srcObject.getTracks();

      tracks.forEach((track) => track.stop());
    },

    async onCapture() {
      const canvas = await getRef.call(this, "canvas");
      const camera = await getRef.call(this, "camera");
      const context = canvas.getContext("2d");

      const aspectRatio = camera.videoWidth / camera.videoHeight;
      let canvasWidth, canvasHeight;

      if (camera.videoWidth > camera.videoHeight) {
        canvasWidth = CANVAS_WIDTH;
        canvasHeight = CANVAS_WIDTH / aspectRatio;
      } else {
        canvasHeight = CANVAS_HEIGHT;
        canvasWidth = CANVAS_HEIGHT * aspectRatio;
      }

      // Set the canvas width and height
      canvas.width = canvasWidth;
      canvas.height = canvasHeight;

      context.drawImage(camera, 0, 0, canvas.width, canvas.height);

      const dataUrl = canvas.toDataURL("image/png");

      this.$emit("capture", dataUrl);

      await this.$nextTick();

      this.isModalVisible = false;
      this.stopCameraStream();
    },
  },
};
</script>

<style lang="scss" scoped>
canvas {
  position: absolute;
  left: -9999px;
}
</style>
